import * as layoutActions from "../actions/layout.actions"

export interface State {
	showRight: boolean
}

export const initialState: State = {
	showRight: false
}

export function reducer(state = initialState, action: layoutActions.LayoutActions): State {
	switch (action.type) {
		case layoutActions.LayoutActionTypes.ToggleView: {
			return {
				...state,
				showRight: !action.payload
			}
		}
		default:
			return state
	}
}
